import { createDataAttribute, CreateDataAttributeProps } from "next-sanity";

import {
  createImageUrlBuilder,
  type SanityImageSource,
} from "@sanity/image-url";

import { dataset, projectId, studioUrl } from "../sanity/api";

type DataAttributeConfig = CreateDataAttributeProps &
  Required<Pick<CreateDataAttributeProps, "id" | "type" | "path">>;

export function dataAttr(config: DataAttributeConfig) {
  return createDataAttribute({
    projectId,
    dataset,
    baseUrl: studioUrl,
  }).combine(config);
}

const builder = createImageUrlBuilder({ projectId, dataset });

type SanityImageAssetHint = {
  asset?: { mimeType?: string; _ref?: string };
};

export const isSanitySvg = (source: SanityImageSource) => {
  const asset = (source as SanityImageAssetHint).asset;
  return (
    asset?.mimeType === "image/svg+xml" ||
    Boolean(asset?._ref?.endsWith("-svg"))
  );
};

export const urlFor = (source: SanityImageSource) => {
  const imageBuilder = builder.image(source);
  const sourceObj = source as SanityImageAssetHint;
  const isPng =
    sourceObj?.asset?.mimeType === "image/png" ||
    sourceObj?.asset?._ref?.endsWith("-png");

  if (isSanitySvg(source)) return imageBuilder;
  if (isPng) return imageBuilder.fit("crop");

  return imageBuilder.format("webp").fit("crop");
};

export function assertValue<T>(v: T | undefined, errorMessage: string): T {
  if (v === undefined) {
    throw new Error(errorMessage);
  }

  return v;
}
